import { IonList } from '@ionic/react';
import { ReactElement } from 'react';
import i18n from '../../../i18n';
import { LoadingButton } from '../../button/loading-button';
import { IonItem } from '../../ionic/IonItem';
import { LoginConfirmProps } from '../login-confirm';

const FailedLogin = (props: LoginConfirmProps): ReactElement => {
  const { loading, startOverClick } = props;
  return (
    <>
      <IonList lines="none">
        <IonItem>
          <p>{i18n.t('common:login_confirm_failed')}</p>
        </IonItem>
      </IonList>
      <br />
      <div className="ion-padding-horizontal">
        <LoadingButton
          loading={loading}
          buttonProps={{
            type: 'submit',
            expand: 'block',
            onClick: startOverClick,
          }}
        >
          {i18n.t('common:login_start_over')}
        </LoadingButton>
      </div>
    </>
  );
};

export { FailedLogin };
